import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import Constants from '../../../definitions/constants';
import LocaleTooling from '../../../tooling/localeTooling';

import Button from '../common/inputs/button';
import Select from '../common/inputs/select';
import FetchAutocompleteList from '../common/inputs/fetchAutocompleteList';
import CheckBox from '../common/inputs/checkBox';

const CalculationUnitsFilter = props => {
  const {
    onChangeFilter,
    filterValues,
    groupsData,
    groupsLoading,
    calculationUnitsData,
    calculationUnitsFetchAction,
    calculationUnitsLoading,
    hideReportValueFilters,
    hideTitle
  } = props;
  return (
    <div className="generate_section calculation_units_filter_wrapper">
      {(!hideTitle && (<h3>{LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="reportFileAdmin.calculationUnitsFiltertitle"/>)}</h3>))}
      <Select 
        value={filterValues["filterGroup"]}
        onChange={onChangeFilter}
        disabled={groupsLoading}
        labelLocale={<FormattedMessage id="periodAdmin.calculationUnitFilterGroupsLabel"/>}
        options={InterfaceTooling.getSelectArrayFromArrayOfObjects(groupsData, "id", "name")}
        data-path="filterGroup"
      />
      <Select 
        value={filterValues["criteria"]}
        onChange={onChangeFilter}
        labelLocale={<FormattedMessage id="periodAdmin.calculationUnitFilterLabel"/>}
        options={InterfaceTooling.getSelectArray("calculationFilters.calculationUnitFilter", "periodAdmin.calculationUnitFilter", false)}
        data-path="criteria"
      />
      {(filterValues["criteria"]!="" && filterValues["criteria"]!=Constants.calculationFilters.calculationUnitFilter.ALL) && (
        <FetchAutocompleteList        
          values={filterValues["calculationUnitsSelected"]}
          onChange={onChangeFilter}
          addSelectLocale={LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id:"periodAdmin.calculationUnitFilterFinderLabel"}))}
          options={InterfaceTooling.getSelectArrayFromArrayOfObjects(calculationUnitsData, "id", "name", false)}
          valueAccesor={"id"}
          labelAccesor={"name"}
          fetchListAction={calculationUnitsFetchAction}
          loadingFetch={calculationUnitsLoading}
          data-path="calculationUnitsSelected"
        />
      )}
      {(!hideReportValueFilters) && (
        <CheckBox 
          data-path="ignoreZeroTotalValue"
          value={filterValues["ignoreZeroTotalValue"]}
          onChange={onChangeFilter}
          labelLocale={LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="periodAdmin.reportsFilterignoreZeroTotalValue"/>)}
        />
      )}
    </div>
  );
};

export default CalculationUnitsFilter;



// WEBPACK FOOTER //
// ./source/client/components/reportFileAdmin/calculationUnitsFilter.jsx